import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {
    isFocused: boolean;
}
export class CurrencyComponent extends React.Component<Props, State> {


  constructor(props: Props) {
        super(props);
        this.state = { isFocused: false };

        let field = this.props.field;
      field.IsDirty = false;
      FormValidationUtils.runJavascript(field);
    }

  formatCurrency = (value: string): string => {
    if (value == null || value === '') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    const locale = this.props.isEng ? 'en-CA' : 'fr-CA';
    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'CAD',
    }).format(num);
    return formatted.replace('$', '$ ');
  }

  stripNonNumeric = (val: string): string => {
    if (val == null) return '';
    let normalized = val.replace(/,/g, '.');
    normalized = normalized.replace(/[^0-9.\-]/g, '');
    const isNegative = normalized.startsWith('-');
    normalized = normalized.replace(/-/g, '');
    const parts = normalized.split('.');
    let result: string;
    if (parts.length > 1) {
      result = parts[0] + '.' + parts.slice(1).join('').substring(0, 2);
    } else {
      result = normalized;
    }
    const final = isNegative ? '-' + result : result;
    return final;
  }

  normalizeValue = (val: string): string => {
    if (val == null || val === '') return '';
    let normalized = val;
    if (normalized.startsWith('.')) normalized = '0' + normalized;
    if (normalized.startsWith('-.')) normalized = '-0' + normalized.substring(1);
    if (normalized.endsWith('.')) normalized = normalized.slice(0, -1);
    return normalized;
  }

  onTextEditChange = (e) => {
    const field = this.props.field;
    const elem = e.originalEvent ? e.originalEvent.target : e.target;
    const rawVal = elem.value;
    const val = this.stripNonNumeric(rawVal);
    field.Value = val;

    FormValidationUtils.markFieldDirty(field);
    FormValidationUtils.validateCurrency(field);

    FormValidationUtils.runJavascript(field);

    this.props.callbackElement(getRootComponent(field));
  }

  onFocus = () => {
    this.setState({ isFocused: true });
  }

  onBlur = () => {
    this.setState({ isFocused: false });
    const field = this.props.field;
    field.Value = this.normalizeValue(field.Value);
    FormValidationUtils.markFieldDirty(field);
    FormValidationUtils.validateCurrency(field);
    this.props.callbackElement(getRootComponent(field));
  }


  render() {
    let field = this.props.field;
    if(!field.Visible) return null;

    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;

    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>
          <div key={'fdLbl_div_' + field.Id} >
            {labelControlArray}
          </div>
          <LiveValidationErrMsg
            field={this.props.field}
            isEng={this.props.isEng}
            key={"LiveValidationErrMsg_" + field.LoadBindName} />
         
          <input className={this.props.field.Valid || !this.props.field.Touched?'ontario-input':'ontario-input ontario-input__error'}
                  id={field.LoadBindName}  key={'fdIpt_currency_' + field.Id}
                  aria-required={field.Optional !== 'Y'}
                  aria-describedby={
                    [!field.Valid && `${field.LoadBindName}-${field.Id}-error`, hintHtml && `hint-text-${field.LoadBindName}`]
                      .filter(Boolean)
                      .join(' ') || undefined
                  }                  aria-invalid={!field.Valid && field.Touched}
                  type="text" inputMode="decimal"
                  autoComplete="off"
                  style={{ ...(field.LengthInPixel && { width: `${field.LengthInPixel}px` }) }}
                  value={this.state.isFocused ? (field.Value ?? '') : this.formatCurrency(field.Value)}
                  readOnly={field.ReadOnly}
                  onChange={this.onTextEditChange}
                  onFocus={this.onFocus}
                  onBlur={this.onBlur} />
        </div>);
    } else {
      controlArray.push(
        <div className='pdf-two-column' >
          <div>{this.props.isEng ? field.ENUTitle : field.FRATitle}</div>
          <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} > {this.formatCurrency(field.Value)}</div>
        </div>
      );
    }

    return controlArray;
  }

}
